import { nextgenApiClient } from '../client';

export function getClients(params = {}) {
  return nextgenApiClient
    .get('/api/clients/list', {
      params: {
        ...params,
        activeOnly: true,
        type: 'C',
      },
    })
    .then(({ data }) => data);
}
